var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { XIcon } from '../icons/index.js';
import { ToastProvider, useToastContext } from './ToastContext.js';
import { ToastIcon } from './ToastIcon.js';
export const ToastComponent = (_a) => {
    var { onClose, status = 'neutral', children, className } = _a, rest = __rest(_a, ["onClose", "status", "children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('max-w-sm w-full shadow-lg rounded-lg overflow-hidden pointer-events-auto border border-line-subdued', 'bg-surface text-content-subdued', 'focus-visible:ring-1 focus:outline-none', className) }, rest),
        React.createElement(ToastProvider, { onClose: onClose, status: status },
            React.createElement(BackgroundProvider, { backgroundType: "surface" }, children))));
};
const ToastContent = props => {
    const { children, title, description, icon, withClose = true, className } = props, rest = __rest(props, ["children", "title", "description", "icon", "withClose", "className"]);
    const { status, onClose } = useToastContext();
    return (React.createElement("div", Object.assign({ className: clsx('p-4 relative', [
            status === 'neutral' && 'bg-surface text-content-subdued',
            status === 'error' && 'bg-surface-negative text-content-on-negative',
            status === 'warning' &&
                'bg-surface-attention text-content-on-attention',
            status === 'success' &&
                'bg-surface-positive text-content-on-positive',
            status === 'info' && 'bg-surface-highlight text-content-on-highlight',
        ], className) }, rest),
        React.createElement("div", { className: "flex items-start text-sm " },
            React.createElement("div", { className: "flex-shrink-0" },
                React.createElement(ToastIcon, { status: status }, icon)),
            React.createElement("div", { className: clsx('ms-3 flex-1', withClose && 'me-8') },
                title && React.createElement("p", { className: "font-bold" }, title),
                description && React.createElement("p", { className: "mt-1" }, description),
                children),
            withClose && (React.createElement("span", { className: "absolute top-0 end-0 flex items-center me-4 mt-4" },
                React.createElement("button", { type: "button", className: "rounded-md inline-flex focus:outline-none focus-visible:ring", onClick: onClose },
                    React.createElement("span", { className: "sr-only" }, "Close"),
                    React.createElement(XIcon, { className: clsx('h-5 w-5', [
                            status === 'neutral' &&
                                'text-content-subdued hover:text-content-hovered',
                            status === 'error' &&
                                'text-content-on-negative hover:text-content-on-negative-hovered',
                            status === 'warning' &&
                                'text-content-on-attention hover:text-content-on-attention',
                            status === 'success' &&
                                'text-content-on-positive hover:text-content-on-positive',
                            status === 'info' &&
                                'text-content-on-highlight hover:text-content-on-highlight',
                        ]), "aria-hidden": "true" })))))));
};
ToastComponent.Content = ToastContent;
//# sourceMappingURL=ToastComponent.js.map